export const CANNY_SDK_URL = 'https://canny.io/sdk.js';
export const CANNY_SDK_ID = 'canny-jssdk';
